module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "cancel-deletion-hourglass.714e127f.svg";